<template>
  <div class="not-found-page">
    <div>
      <div class="not-found-title">404</div>
      <div class="not-found-name">无法找到您请求的页面。</div>
      <div class="not-found-en">Please check your url.</div>
    </div>
    <div>
      <img class="not-found-img" src="../../public/static/notFound.png">
    </div>
    <div>
      <a-button @click="$router.push('/home')">返回首页</a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'notFound',
  created() {
    document.title = '无法找到当前页面';
  }
}
</script>
<style lang="scss">
@import "../assets/scss/constant";

.not-found-page {
  //background-color: #FAFAFB;
  border-radius: 10px;
  padding: 100px 120px;
  display: flex;
  justify-content: space-between;

  .not-found-title {
    color: $primaryColor;
    font-size: 80px;
    font-weight: 800;
  }

  .not-found-name {
    color: #333333;
    font-size: 24px;
    font-weight: 500;
    margin-top: 10px;
  }

  .not-found-en {
    color: #999999;
    font-size: 20px;
    font-weight: 500;
    margin-top: 18px;
  }

  .not-found-btn {
    padding: 12px 30px;
    background-color: $primaryColor;
    border: none;
    border-radius: 4px;
    color: #FFFFFF;
    font-size: 20px;
    margin-top: 40px;

  }

  .not-found-img {
    width: 500px;
  }
}
</style>
